"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _overlay = require("@alicd/next/lib/overlay");

var _overlay2 = _interopRequireDefault(_overlay);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _icon = require("@alicd/next/lib/icon");

var _icon2 = _interopRequireDefault(_icon);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _set = require("babel-runtime/core-js/set");

var _set2 = _interopRequireDefault(_set);

var _map = require("babel-runtime/core-js/map");

var _map2 = _interopRequireDefault(_map);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function updateParentSet(children) {
    var itemsParent = new _map2.default();
    var fillParent = function fillParent(children, set, parentKey) {
        return _react2.default.Children.forEach(children, function (node, i) {
            var key = node.key || parentKey + "-" + i;
            itemsParent.set(key, set);
            var newSet = new _set2.default(set);newSet.add(key);
            fillParent(node.props.children, newSet, key);
        });
    };
    fillParent(children, new _set2.default(), "");
    return itemsParent;
}

function updateChildrenCount(children) {
    var ret = new _map2.default();
    var fill = function fill(children, parentKey) {
        return _react2.default.Children.forEach(children, function (node, i) {
            var key = node.key || parentKey + "-" + i;
            ret.set(key, _react2.default.Children.count(node.props.children));
            fill(node.props.children, key);
        });
    };
    fill(children, "");
    return ret;
}

var StorageNav = function (_Component) {
    (0, _inherits3.default)(StorageNav, _Component);

    function StorageNav(props) {
        (0, _classCallCheck3.default)(this, StorageNav);

        var _this = (0, _possibleConstructorReturn3.default)(this, (StorageNav.__proto__ || (0, _getPrototypeOf2.default)(StorageNav)).call(this, props));

        _this.state = {
            haveMouse: true,
            hoveredKey: props.hoveredKey
        };

        _this.menuOpenTimeoutContainer = [0];
        _this.menuAnimEnabledContainer = [true];
        _this.getRefOuter = _this.getRefOuter.bind(_this);
        _this.handleClose = _this.handleClose.bind(_this);
        _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
        _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
        _this.handleMouseMove = _this.handleMouseMove.bind(_this);
        _this.checkMouseAndCloseIfNeeded = _this.checkMouseAndCloseIfNeeded.bind(_this);
        _this.handleHover = _this.handleHover.bind(_this);
        _this.handleHoverExit = _this.handleHoverExit.bind(_this);
        _this.handleCloseByIcon = _this.handleCloseByIcon.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(StorageNav, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.itemsParent = updateParentSet(this.props.children);
            this.childrenCount = updateChildrenCount(this.props.children);
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.children != nextProps.children) {
                this.itemsParent = updateParentSet(this.props.children);
                this.childrenCount = updateChildrenCount(this.props.children);
            }
        }
    }, {
        key: "componentWillUpdate",
        value: function componentWillUpdate(nextProps, nextState) {
            var _this2 = this;

            if (this.props.visible) {
                var newHoveredKey = nextState.hoveredKey;
                if ("hoveredKey" in nextProps && nextProps.hoveredKey != nextState.hoveredKey) {
                    newHoveredKey = nextProps.hoveredKey;
                }

                var menuWrap = _reactDom2.default.findDOMNode(this.refs.menuWrap);
                if (menuWrap && newHoveredKey != this.state.hoveredKey) {
                    if (menuWrap) {
                        var enableAnim = function enableAnim() {
                            _this2.menuAnimEnabledContainer = [true];
                            menuWrap.classList.remove("cn-stnav-noanim");
                        };
                        var disableAnim = function disableAnim() {
                            _this2.menuAnimEnabledContainer = [false];
                            menuWrap.classList.add("cn-stnav-noanim");
                        };
                        var getLevelOfKey = function getLevelOfKey(key) {
                            if (_this2.itemsParent.has(key)) {
                                return _this2.itemsParent.get(key).size + !!_this2.childrenCount.get(key);
                            } else {
                                return 0;
                            }
                        };

                        if (newHoveredKey && this.state.hoveredKey) {
                            if (getLevelOfKey(newHoveredKey) == getLevelOfKey(this.state.hoveredKey)) {
                                disableAnim();
                            } else {
                                enableAnim();
                            }
                        } else {
                            enableAnim();
                        }
                    }
                }
            }
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
            if ("hoveredKey" in this.props && this.state.hoveredKey != this.props.hoveredKey) {
                this.setState({ hoveredKey: this.props.hoveredKey });
            }
        }
    }, {
        key: "getChildContext",
        value: function getChildContext() {
            return {
                cruiStorageNavHoveredKey: this.state.hoveredKey,
                cruiStorageNavHandleHover: this.handleHover,
                cruiStorageNavItemsParent: this.itemsParent,
                cruiStorageNavHandleExit: this.handleHoverExit,
                cruiStorageNavMenuOpenTimeout: this.props.menuOpenTimeout,
                cruiStorageNavMenuOpenTimeoutHandleContainer: this.menuOpenTimeoutContainer,
                cruiStorageNavMenuAnimEnabledContainer: this.menuAnimEnabledContainer
            };
        }
    }, {
        key: "handleHover",
        value: function handleHover(hoveredKey) {
            if (!this.props.hoveredKey) {
                this.setState({ hoveredKey: hoveredKey });
            }
            if (hoveredKey && typeof this.props.onHover == "function") {
                this.props.onHover(hoveredKey);
            }
        }
    }, {
        key: "handleHoverExit",
        value: function handleHoverExit(exitFrom) {
            if (this.state.hoveredKey == exitFrom) {
                // if (!this.props.hoveredKey) {
                //     this.setState({ hoveredKey: undefined });
                // }
                // typeof this.props.onHover == "function" &&
                // this.props.onHover(undefined);
            }
        }
    }, {
        key: "handleCloseByIcon",
        value: function handleCloseByIcon() {
            this.props.canCloseByIconClick && this.handleClose();
        }
    }, {
        key: "handleClose",
        value: function handleClose() {
            this.props.onClose && this.props.onClose();
        }
    }, {
        key: "handleMouseEnter",
        value: function handleMouseEnter(e) {
            this.mouseCatched();
            typeof this.props.onMouseEnter == "function" && this.props.onMouseEnter(e);
        }
    }, {
        key: "handleMouseMove",
        value: function handleMouseMove(e) {
            this.mouseCatched();
            typeof this.props.onMouseMove == "function" && this.props.onMouseMove(e);
        }
    }, {
        key: "handleMouseLeave",
        value: function handleMouseLeave(e) {
            this.setState({ haveMouse: false });
            if (this.props.mouseLeaveTimeout) {
                setTimeout(this.checkMouseAndCloseIfNeeded, this.props.mouseLeaveTimeout);
            }
            typeof this.props.onMouseLeave == "function" && this.props.onMouseLeave(e);
        }
    }, {
        key: "mouseCatched",
        value: function mouseCatched() {
            if (!this.state.haveMouse) {
                this.setState({ haveMouse: true });
            }
        }
    }, {
        key: "checkMouseAndCloseIfNeeded",
        value: function checkMouseAndCloseIfNeeded() {
            if (!this.state.haveMouse) {
                this.handleClose();
            }
        }
    }, {
        key: "getRefOuter",
        value: function getRefOuter() {
            return this.refs.outer;
        }
    }, {
        key: "renderCloseIcon",
        value: function renderCloseIcon() {
            if (typeof this.props.closeIcon == "string") {
                return _react2.default.createElement(_icon2.default, { className: "cn-stnav-close", type: this.props.closeIcon });
            } else {
                return this.props.closeIcon;
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                className = _props.className,
                style = _props.style,
                visible = _props.visible,
                children = _props.children,
                mouseLeaveTimeout = _props.mouseLeaveTimeout,
                menuOpenTimeout = _props.menuOpenTimeout,
                closeIcon = _props.closeIcon,
                onMouseEnter = _props.onMouseEnter,
                onMouseLeave = _props.onMouseLeave,
                onMouseMove = _props.onMouseMove,
                hoveredKey = _props.hoveredKey,
                onHover = _props.onHover,
                onClose = _props.onClose,
                animation = _props.animation,
                canCloseByIconClick = _props.canCloseByIconClick,
                other = (0, _objectWithoutProperties3.default)(_props, ["className", "style", "visible", "children", "mouseLeaveTimeout", "menuOpenTimeout", "closeIcon", "onMouseEnter", "onMouseLeave", "onMouseMove", "hoveredKey", "onHover", "onClose", "animation", "canCloseByIconClick"]);


            return _react2.default.createElement(
                "div",
                { className: "cn-stnav-outer", ref: "outer" },
                _react2.default.createElement(
                    _overlay2.default,
                    (0, _extends3.default)({
                        className: "cn-stnav-wrap",
                        align: "lt lt",
                        shouldUpdatePosition: true,
                        onRequestClose: this.handleClose,
                        animation: animation ? { "in": "fadeIn", "out": "fadeOut" } : false
                    }, other, {
                        visible: visible
                    }),
                    _react2.default.createElement(
                        "div",
                        { className: "cn-stnav-donot-merge" },
                        _react2.default.createElement(
                            "div",
                            {
                                className: (0, _classnames2.default)("cn-stnav-menu", className),
                                style: (0, _extends3.default)({ zIndex: 10000 }, style),
                                onMouseEnter: this.handleMouseEnter,
                                onMouseMove: this.handleMouseMove,
                                onMouseLeave: this.handleMouseLeave,
                                ref: "menuWrap"
                            },
                            _react2.default.createElement(
                                "div",
                                { className: "cn-stnav-menu-inner" },
                                _react2.default.createElement("div", { className: "cn-stnav-menu-bg" }),
                                _react2.default.createElement(
                                    "div",
                                    { className: "cn-stnav-overlay-toggle", onClick: this.handleCloseByIcon },
                                    this.renderCloseIcon()
                                ),
                                _react2.default.Children.map(children, function (n, i) {
                                    return _react2.default.cloneElement(n, { level: 0, parent: null, eventKey: n.key || "-" + i });
                                })
                            )
                        )
                    )
                )
            );
        }
    }]);
    return StorageNav;
}(_react.Component);

StorageNav.propTypes = {
    className: _propTypes2.default.string,
    visible: _propTypes2.default.bool,
    onClose: _propTypes2.default.func,
    mouseLeaveTimeout: _propTypes2.default.number,
    menuOpenTimeout: _propTypes2.default.number,
    closeIcon: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string]),
    onMouseEnter: _propTypes2.default.func,
    onMouseLeave: _propTypes2.default.func,
    onMouseMove: _propTypes2.default.func,
    hoveredKey: _propTypes2.default.string,
    onHover: _propTypes2.default.func,
    animation: _propTypes2.default.bool,
    canCloseByIconClick: _propTypes2.default.bool
};
StorageNav.defaultProps = {
    closeIcon: "category",
    mouseLeaveTimeout: 300,
    menuOpenTimeout: 128,
    style: {},
    animation: true,
    canCloseByIconClick: true
};
StorageNav.childContextTypes = {
    cruiStorageNavHoveredKey: _propTypes2.default.string,
    cruiStorageNavHandleHover: _propTypes2.default.func,
    cruiStorageNavHandleExit: _propTypes2.default.func,
    cruiStorageNavItemsParent: _propTypes2.default.object,
    cruiStorageNavMenuOpenTimeout: _propTypes2.default.number,
    cruiStorageNavMenuOpenTimeoutHandleContainer: _propTypes2.default.object,
    cruiStorageNavMenuAnimEnabledContainer: _propTypes2.default.object
};
exports.default = StorageNav;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-storage-nav@0.0.16@@alicd/crui-storage-nav/lib/StorageNav.js
// module id = 675
// module chunks = 0